var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2799 0.0830078L15.9166 4.72217V11.2805L11.2799 15.9163H4.72159L0.083252 11.2797V4.72134L4.72159 0.0830078H11.2799ZM10.5891 1.74967H5.41159L1.75075 5.41217V10.5897L5.41159 14.2513H10.5891L14.2508 10.5897V5.41134L10.5891 1.75051V1.74967ZM4.66658 7.16634H11.3333V8.83301H4.66658V7.16634Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.fb84ca3c09dcdbba2b03eb25c5af2d15.svg";
export { ForwardRef as ReactComponent };